var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-container"},[_c('Chart',{staticClass:"chart my-2",attrs:{"options":_vm.chartData,"highcharts":_vm.hcInst}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }